import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EditMenuComponent } from './edit-menu/edit-menu.component';
import { ActivatedRoute } from '@angular/router';
import { faEdit,faMinus,faPlus,faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ngx-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  faEdit = faEdit;
  faMinus = faMinus;
  faPlus = faPlus;
  faTimes = faTimes;
  currentEvent: string = 'start do something';
  menu:any = [];
  parentId;
  childId;
  enfants:any = [];
  id;
  myTree :any= [];
  name;
  target;
  typeTarget;
  href;
  data = 0;
  content:any = []
   tmps: any =[];   
   hideLoader = true;
   hideButon = false;
   item;
   nameItem;
   contentItems:any =[];
  
  constructor(private route:ActivatedRoute,private dialogService: NbDialogService,private apiService:ApiService, private toar:NbToastrService) { }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
     //this.getTree();
     this.getMenuListe();
    
  }

 

    getMenuListe(){
      this.apiService.getOneMenuProvider(this.id).subscribe((data:any) =>{
      
          this.nameItem = data.nom;
         
          this.nameItem = data.nom ;  
      this.contentItems = JSON.parse(data.items) ; 
     
        this.myTree = this.contentItems.map(tmp => {
          return {
           
            name: tmp.name,
            id: tmp.id,
           options:tmp.options,          
            childrens: tmp.childrens
            
          };
         
        });
      
      })
    }

    
     eachRecursive(obj,dat){
        for (var k in obj)
        {
            if (typeof obj[k] == "object" && obj[k] !== null){
              this.eachRecursive(obj[k],dat);
              // console.log(obj[k]);
              if(obj[k].id ===dat.id){
              
                obj[k].options['href'] = dat.href
                obj[k].options['target'] = dat.target;
                obj[k].options['typeTarget'] = dat.typeTarget;
                obj[k].options['title'] = dat.title;

                return obj[k];
              
              }
            }
              
        }
    }



  config = {
    showActionButtons: true,
    showAddButtons: true,
    showRenameButtons: true,
    showDeleteButtons: true,
    
    showRootActionButtons: true, // set false to hide root action buttons.
    enableExpandButtons: true,
    enableDragging: true,
    rootTitle: this.nameItem,
    validationText: 'cinq lettres minimum',
    minCharacterLength: 5,
    setItemsAsLinks: false,
    setFontSize: 32,
    setIconSize: 16
};




onDragStart(event) {
   this.currentEvent = ' on drag start';
   console.log(event);
   console.log(this.myTree);
}
onDrop(event) {
  this.currentEvent = 'on drop';
  console.log(event);
}
onAllowDrop(event) {
  this.currentEvent = 'on allow drop';
}
onDragEnter(event) {
  this.currentEvent = 'on drag enter';
}
onDragLeave(event) {
  this.currentEvent = 'on drag leave';
}




onAddItem(event) {
  this.currentEvent = 'on add item';
  const renam = event.element.name;
 var maDialog=  this.dialogService.open(EditMenuComponent,{context: { id: this.childId, lien:event.element.href,cible:event.element.target, typeT:event.element.typeTarget}});
   
 maDialog.onClose.subscribe(data =>{
     

     if(data !==undefined){
       console.log(data);
      event.element.name =data.name;
      
      event.element.options = {
       currentlyDragging: false,
       destenationBottom: false,
       destenationTop: false,
       disabled: false,
       draggable: true,
       edit: false,
       hidden: false,
       hideChildrens: false,
       href: data.href,
       lien:data.lien,
       position: 2,
       showActionButtons: true,
       showDeleteButton: true,
       showExpandButton: true,
       typeTarget: data.typeTarget,
       target: data.target,
       icon: null
      }
     } else  {

      event.element.name = renam;
      event.element.options = {
       currentlyDragging: false,
       destenationBottom: false,
       destenationTop: false,
       disabled: false,
       draggable: true,
       edit: false,
       hidden: false,
       hideChildrens: false,
       href: event.element.options.href,
       lien: event.element.options.lien,
       position: 2,
       showActionButtons: true,
       showDeleteButton: true,
       showExpandButton: true,
       typeTarget: event.element.options.typeTarget,
       target: event.element.options.target,
       icon: null
      }
   }

    })
 

  console.log(this.myTree) 
}

onStartRenameItem(event) {
  this.currentEvent = 'on start edit item';
  console.log(event);

  const renam = event.element.name;
 
 var maDialog=  this.dialogService.open(EditMenuComponent,{context: { id: this.childId, lien:event.element.options.href,cible:event.element.options.target, typeT:event.element.options.typeTarget, nome:event.element.name}});
   
 maDialog.onClose.subscribe(data =>{       
 
     
  if(data !==undefined){
    // console.log(data);
    event.element.name =data.name;
     
    event.element.options = {
     currentlyDragging: false,
     destenationBottom: false,
     destenationTop: false,
     disabled: false,
     draggable: true,
     edit: false,
     hidden: false,
     hideChildrens: false,
     href: data.href,
     lien:data.lien,
     position: 2,
     showActionButtons: true,
     showDeleteButton: true,
     showExpandButton: true,
     typeTarget: data.typeTarget,
     target: data.target,
     icon: null
    }

  } else  {

     event.element.name = renam;
     event.element.options = {
      currentlyDragging: false,
      destenationBottom: false,
      destenationTop: false,
      disabled: false,
      draggable: true,
      edit: false,
      hidden: false,
      hideChildrens: false,
      href: event.element.options.href,
      lien: event.element.options.lien,
      position: 2,
      showActionButtons: true,
      showDeleteButton: true,
      showExpandButton: true,
      typeTarget: event.element.options.typeTarget,
      target: event.element.options.target,
      icon: null
     }
  }
     

    })
 
}
onFinishRenameItem(event) {
  this.currentEvent = 'on finish edit item';
  console.log(this.myTree);
}
onStartDeleteItem(event) {
  console.log('start delete');
  this.currentEvent = 'on start delete item';
}
onFinishDeleteItem(event) {
  console.log('finish delete');
  this.currentEvent = 'on finish delete item';
  console.log(this.myTree);
}
onCancelDeleteItem(event) {
  console.log('cancel delete');
  this.currentEvent = 'on cancel delete item';
}

saveMenu(){
  this.hideLoader = false;
  this.hideButon = true;
  console.log(this.myTree);

  this.apiService.updateMenuProvider(this.id,this.myTree).subscribe(data =>{
    this.getMenuListe();
    this.toar.success("Menu modifié avec success","success");
    this.hideLoader = true;
    this.hideButon = false;
    console.log(data);
  },(err) =>{
    this.toar.danger("Erreur de modification de menu, réessayez ","erreur");
    console.log(err);
    this.hideLoader = true;
    this.hideButon = false;
  })
}


}


      // this.content.push( {"name": this. myTree[key].name},{ "id": this. myTree[key].id,},{ "childrens": this. myTree[key].childrens},{ "options": this. myTree[key].options});